import { Action } from '@ngrx/store';
import {
    ActionOptionsArgs,
    BaseAction,
    SynchronisableAction
} from '../../../core/store/actions/base-actions';
import { Task } from './task.model';
import { ITaskFilters } from './task.reducer';

export const ENTITY = 'task';
export const SUBMIT = '[Task] Submit';
export const REHYDRATE = '[Task] Rehydrate';
export const REMOVE = '[Task] Remove';
export const SET_FILTER = '[Task] Set Filter';
export const SET_TOTAL = '[Task] Set Total';
export const LOAD_NEXT_PAGE = '[Task] Load Next Page';

export class SubmitAction extends SynchronisableAction {
    readonly entity = ENTITY;
    readonly type = SUBMIT;

    constructor(public payload: Task, options?: ActionOptionsArgs) {
        super(payload, options);
    }

    getKey(): string {
        return `${this.entity}:entity:${this.payload.id}`;
    }
}

export class RehydrateAction implements Action {
    readonly type = REHYDRATE;

    constructor(public payload: Array<Task>) {

    }
}

export class RemoveAction extends SynchronisableAction {
    readonly entity = ENTITY;
    readonly type = REMOVE;

    constructor(public payload: Task, options?: ActionOptionsArgs) {
        super(payload, options);
    }

    getKey(): string {
        return `${this.entity}:entity:${this.payload.id}`;
    }
}

export class SetFilterAction extends BaseAction {
    readonly type = SET_FILTER;
    readonly entity = ENTITY;

    constructor(public payload: ITaskFilters, options?: ActionOptionsArgs) {
        super(payload, options);
    }
}

export class SetTotalAction extends BaseAction {
    readonly type = SET_TOTAL;
    readonly entity = ENTITY;

    constructor(public payload: number, options?: ActionOptionsArgs) {
        super(payload, options);
    }
}

export class LoadNextPage extends BaseAction {
    readonly type = LOAD_NEXT_PAGE;
    readonly entity = ENTITY;

    constructor() {
        super(undefined);
    }
}

export type Actions
    = SubmitAction
    | RehydrateAction
    | RemoveAction
    | SetFilterAction
    | SetTotalAction
    | LoadNextPage;



// WEBPACK FOOTER //
// ./src/vas/business-objects/task/task.actions.ts